<template :routePreventDialog="routePreventDialog" :customClass="'leave-update'">
  <div v-if="drawer">
    <v-navigation-drawer v-model="drawer" fixed width="700" right temporary stateless style="z-index: 99">
      <div class="drawer-wrapper">
        <v-flex class="py-1 px-5 d-flex align-items-center white--text cyan">
          <div class="form-title my-auto" v-if="leaveCreate.id > 0">
            Update Leave
          </div>
          <div class="form-title my-auto" v-else>Create Leave</div>
          <v-spacer></v-spacer>
          <v-btn depressed tile :disabled="!formValid || formLoading || pageLoading" :loading="formLoading"
            class="custom-bold-button" color="indigo darken-2 white--text" v-on:click="CreateOrUpdateLeave">Save
          </v-btn>
          <!-- <v-btn tile color="" class="ml-2" v-on:click="$emit('close')" -->
          <v-btn depressed tile color="" class="ml-2" v-on:click="confirmDialog = true">Cancel</v-btn>
        </v-flex>
        <v-form ref="leaveForm" id="leaveForm" v-model.trim="formValid" lazy-validation
          v-on:submit.stop.prevent="CreateOrUpdateLeave">
          <div class="drawer-content pt-5 px-5">
            <div class="d-form-grp mb-2" v-if="!leaveCreate.id">
              <label class="my-auto fw-500 required" required>Select Cleaner</label>
              <v-autocomplete hide-details dense solo flat placeholder="Select Staff" :items="userList" clearable
                :disabled="pageLoading" :loading="pageLoading" item-value="id" item-text="full_name"
                @input="onStaffInput" v-on:change="getCategoryOptions" v-model.trim="leaveCreate.staff" :rules="[
                  validateRules.required(leaveCreate.staff, 'Select Staff'),
                ]"></v-autocomplete>
            </div>

            <template v-if="leaveCreate && leaveCreate.staff != null">
              <div class="mb-3 d-flex blue lighten-5 pa-2">
                <div class="profile-img">
                  <v-avatar size="100" class="mr-4">
                    <img v-if="userData?.engineer?.profile_logo?.file?.url"
                      :src="userData?.engineer?.profile_logo?.file?.url" />
                    <img v-else src="https://ams-dev.businessthrust.com//media/misc/no_photo_found.png" />
                  </v-avatar>
                </div>
                <div class="profile-desc">
                  <div class="mb-2">
                    <span class="fw-600">Name : </span>
                    <span class="fw-500" v-if="userData && userData.full_name">{{ userData.full_name }}</span>
                  </div>
                  <div class="mb-2">
                    <span class="fw-600">Email : </span>
                    <span class="fw-500" v-if="userData && userData.user_email">{{ userData.user_email }}</span>
                  </div>
                  <div class="mb-2">
                    <span class="fw-600">Phone Number : </span>
                    <span class="fw-500" v-if="userData && userData.phone_number">{{ userData.phone_number }}</span>
                  </div>

                  <div class="mb-2">
                    <span class="fw-600">Designation : </span>
                    <v-chip color="primary" label outlined x-small class="ml-2 text-capitalize"
                      v-if="userData && userData.engineer?.designation">
                      <template v-if="userData.engineer?.designation">{{
                        userData.engineer?.designation?.text
                      }}</template>
                    </v-chip>

                    <em v-else class="text-muted">no designation</em>
                    <!-- <template v-else>{{ userData.user_designation }}</template> -->
                  </div>
                  <div class="mb-2" v-if="false">
                    <span class="fw-600">Probation Period : </span>
                    <span class="fw-500" v-if="userData && userData.probation">{{ userData.probation }}</span>
                  </div>
                </div>
              </div>
            </template>
            <span v-if="userData && userData.full_name">
              <div>
                <v-radio-group v-model="recurringSchedule.type" row dense hide-details class="mt-0"
                  @change="updateValues">
                  <v-radio label="Date Range" value="date_range" class="ma-0 mr-2"></v-radio>
                  <v-radio label="Weekly" value="weekly" class="ma-0 mr-2"></v-radio>
                  <v-radio label="Monthly" value="monthly" class="ma-0 mr-2"></v-radio>
                </v-radio-group>
              </div>
              <div v-if="recurringSchedule.type === 'weekly'" class="mt-4">
                <v-row v-if="recurringSchedule?.type == 'weekly'">
                  <v-col class="py-0 my-0" md="2" v-for="(weekday, index) in weekDays" :key="`job-weekday-${index}`">
                    <v-checkbox color="cyan" :label="weekday.long_name" :value="weekday.id"
                      v-model="recurringSchedule.weeks" hide-details class="mt-0"
                      @change="updateSelection(weekday.id)" />
                  </v-col>
                </v-row>
              </div>
              <div v-if="recurringSchedule.type === 'monthly'" class="mt-5">
                <v-radio-group :disabled="pageLoading" class="mt-0" hide-details mandatory
                  :value="recurringSchedule.recurring_pattern" v-on:change="
                    updateScheduleState(
                      'dbRecurringSchedule.recurring_pattern',
                      $event
                    )
                    ">
                  <v-radio :disabled="pageLoading" :value="1" hide-details color="cyan">
                    <template v-slot:label>
                      <div :class="{
                        'disabled-rw pointer-events-none':
                          recurringSchedule.recurring_pattern != 1,
                      }" class="d-flex align-center font-weight-500">
                        <label class="text-center my-0 ml-2">Selection by Date</label>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio :disabled="pageLoading" :value="2" hide-details color="cyan">
                    <template v-slot:label>
                      <div :class="{
                        'disabled-rw pointer-events-none':
                          recurringSchedule.recurring_pattern != 2,
                      }" class="d-flex align-center font-weight-500">
                        <div style="width: 150px">
                          <v-select dense filled :disabled="pageLoading" item-color="cyan" :items="durationList"
                            item-text="long_name" item-value="id" placeholder="Select Day"
                            v-model="recurringSchedule.week_day" solo flat hide-details color="cyan" />
                        </div>
                        <div style="width: 150px">
                          <v-select dense filled :disabled="pageLoading" item-color="cyan" item-text="long_name"
                            item-value="id" :items="weekDays" placeholder="Select Week Day"
                            v-model="recurringSchedule.week_count" solo flat hide-details color="cyan" />
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
              <v-col md="12">
                <label class="ml-2" for="visit-one-off-start-date">Start Date</label>
                <DatePicker :disabledDates="allowedDates" :disabled="pageLoading" solo flat v-on:change="
                  updateScheduleState(
                    'dbRecurringSchedule.start_date',
                    $event
                  );
                updateEndDate(true);
                " v-model="recurringSchedule.start_date" key="visit-one-off-start-date" id="visit-one-off-start-date"
                  placeholder="Start Date" />
              </v-col>
              <div class="mt-5 mb-5">
                <v-radio-group :disabled="pageLoading" class="mt-5" hide-details mandatory
                  v-model="recurringSchedule.end_mode" row @change="updateLeaveOccurrence">
                  <div class="d-flex flex-wrap">
                    <v-radio :disabled="pageLoading" :value="2" hide-details color="cyan" class="mr-6"
                      style="max-width: 365px">
                      <template v-slot:label>
                        <div class="d-flex align-center" :class="{
                          'disabled-rw pointer-events-none':
                            recurringSchedule.end_mode != 2,
                        }">
                          <div>End after</div>
                          <div class="mx-2">
                            <v-text-field dense :disabled="pageLoading || recurringSchedule.end_mode != 2
                              " filled :value="recurringSchedule.occurrence" type="number" v-on:change="
                                updateScheduleState(
                                  'dbRecurringSchedule.occurrence',
                                  $event
                                ), updateScheduleState('dbScheduleOutput', [])" placeholder=" occurrences" solo flat
                              color="cyan" style="max-width: 80px" :rules="[
                                validateRules.maxLength(recurringSchedule.occurrence, 'Select occurrence', 365),
                              ]" />
                          </div>
                          <div>occurrences</div>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio :disabled="pageLoading" :value="3" hide-details color="cyan" @click="updateEndDate(true)"
                      style="max-width: 319px">
                      <template v-slot:label>
                        <div class="d-flex align-center" :class="{
                          'disabled-rw pointer-events-none':
                            recurringSchedule.end_mode != 3,
                        }">
                          <div class="mr-2">End after
                          </div>
                          <DatePicker :value="recurringSchedule.end_date" :defaultDate="recurringSchedule.end_date"
                            :disabled="pageLoading || recurringSchedule.end_mode != 3" :disabledDates="allowedDates"
                            :min-date="recurringSchedule.start_date" key="visit-recurring-end-date" solo flat
                            placeholder="Select End Date" v-on:change="
                              updateScheduleState(
                                'dbRecurringSchedule.end_date',
                                $event
                              )
                              " />
                        </div>
                      </template>
                    </v-radio>
                  </div>
                </v-radio-group>
              </div>
              <div> 
                <v-btn class="custom-bold-button" @click="leaveDialog = true" :disabled="!recurringSchedule.type"
                  color="cyan white--text">
                  View Leave Schedule
                </v-btn>
              </div>
            </span>
            <div class="d-form-grp mt-4">
              <label class="font-weight-700 font-size-16">Leave Category</label>
              <v-autocomplete :items="categoryList" dense. filled color="cyan" item-color="cyan" solo flat
                v-model.trim="leaveCreate.category" append-outer-icon="mdi-cog" placeholder="Select  Leave Category"
                v-on:click:append-outer="manageCategoryDialog = true" item-text="name" item-value="name"
                class="width-100 new-height" hide-details>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title v-html="'No Category(s) Found.'"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>

              <template>
                <ManageLeaveCategory :d-dialog="manageCategoryDialog" :e_designation="categoryList"
                  v-on:close-dialog="manageCategoryDialog = false" :exist-category="leaveCreate.category"
                  v-on:get-categories="getOptions"></ManageLeaveCategory>
              </template>

            </div>
            <div class="d-form-grp mt-4">
              <label class="input-label fw-500 required">Reason for leave</label>
              <TextAreaField auto-grow dense filled color="cyan" v-model.trim="leaveCreate.reason" placeholder="Remarks"
                solo flat row-height="12" counter="100" />
            </div>
            <ShowLeaveSchedule :dialog="leaveDialog" v-on:close="leaveDialog = false" v-on:next=" nextStepSchedule()"
              v-if="scheduleLeaveOutput.length > 0" />
            <div class="">
              <div class="d-flex pt-1">
                <label class="fw-500">Attachment</label>
              </div>
            </div>
            <FileUpload v-model="files"></FileUpload>
          </div>
        </v-form>
      </div>
    </v-navigation-drawer>
    <Dialog :common-dialog="statusDialog" :dialog-width="640">
      <template v-slot:title>
        <div class="d-flex">
          <div>Confirmed<br /></div>
        </div>
      </template>
      <template v-slot:body>
        <p class="btx-p m-0 text-align-center">
          <template v-for="(row, index) in visitArr">
            <span :key="index">
              <h3 class="font-size-16 font-weight-500 delete-text">
                <span class="font-weight-700" v-if="userData && userData.full_name">{{ userData.full_name }}</span>
                is already assigned to
                <span class="font-weight-700" color="red">{{
                  row.barcode
                }}</span>
                on
                <!-- {{ formatDate(row.started_at)}} -->
                {{ formatDate(row.started_at) }}
                {{ formatDateTimeStart(row.started_at) }} -
                {{ formatetimedata(row.finished_at) }}
              </h3>
            </span>
          </template>
        </p>
      </template>

      <template v-slot:action>
        <v-btn class="mx-2 custom-grey-border custom-bold-button white--text" color="cyan"
          style="min-width: 78px !important" v-on:click="continueData">
          Continue
        </v-btn>
        <v-btn class="mx-2 custom-grey-border custom-bold-button" v-on:click="statusDialog = false">
          Cancel
        </v-btn>
      </template>
    </Dialog>
    <Dialog :commonDialog="confirmDialog" :dialogWidth="600">
      <template v-slot:body>
        <v-layout>
          <v-flex md2 class="text-center">
            <!--begin::Svg Icon-->
            <inline-svg width="50" :src="$assetURL('media/custom-svg/attention-circle.svg')" />
            <!--end::Svg Icon-->
          </v-flex>
          <v-flex md10>
            <p class="font-weight-700">
              Are you sure you want to leave this page?
            </p>
            <v-layout>
              <v-flex>
                <v-btn depressed class="mr-2 custom-grey-border custom-bold-button white--text" color="cyan" small
                  v-on:click="confirmDialog = false">
                  Stay on this page
                </v-btn>
                <v-btn depressed class="mx-2 custom-grey-border custom-bold-button" small @click="
                  () => {
                    updateValues();
                    goBack();
                  }
                ">
                  Leave this page
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </Dialog>
  </div>
</template>
<style scoped>
/* .bt-table .v-data-table__wrapper {
    height: auto;
    overflow: auto;
} */
</style>
<script>
/* import MainMixin from "@/core/mixins/main.mixin.js"; */
// import DatePicker from "@/view/components/main-job/QDatePicker.vue";
import DatePicker from "@/view/pages/partials/LeaveDatepicker.vue";
import ManageLeaveCategory from "@/view/pages/partials/ManageLeaveCategory";
import CommonMixin from "@/core/plugins/common-mixin";
import { POST, GET } from "@/core/services/store/request.module";
import moment from "moment-timezone";
import { SET_MESSAGE, SET_ERROR } from "@/core/services/store/common.module";
import { toSafeInteger, filter, find, toString } from "lodash";
import { getCurrentUser } from "@/core/services/jwt.service";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog";
import FileUpload from "@/view/components/app-component/FileInput.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import {
  GET_LEAVE_STATUS,
  UPDATE_SCHEDULE_STATE,
  GET_RECURRING_LEAVE_DATE,
  UPDATE_DEFAULT_DATE,
} from "@/core/services/store/leave.module";
import ShowLeaveSchedule from "@/view/components/ShowLeaveSchedule.vue";
import { mapGetters } from "vuex";

/* import { LeaveEventBus } from "@/core/lib/leave.form.lib"; */
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "CreateLeave",
  components: {
    DatePicker,
    FileUpload,
    ShowLeaveSchedule,
    ManageLeaveCategory,
    Dialog,
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    leaveUpdateData: {
      type: Object,
    },
    leaveIds: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      leaveDialog: false,
      manageCategoryDialog: false,
      confirmDialog: false,
      formLoading: false,
      probisionTime: 0,
      excludesDates: [],
      existedLeave: [],
      formValid: true,
      minDate: new Date().toISOString().substr(0, 10),
      leave: null,
      updateDialog: false,
      apprveLeaves: 0,
      pendingLeaves: 0,
      statusDialog: false,
      allocated: 0,
      diableDay: false,
      pageLoading: false,
      userData: {},
      categoryList: new Array(),
      is_visit_validated: 1,
      visitArr: [],
      start_date: null,
      end_date: null,
      maxDate: null,
      weekEndDays: 0,
      userList: new Array(),
      remainingLeaves: null,
      holidays: [],
      files: [
        {
          file: null,
          name: null,
        },
      ],
      leaveList: [
        {
          category: null,
          maxdays: null,
          remainig_days: null,
        },
      ],
      leaveCreate: new Object({
        id: null,
        staff: null,
        category: 0,
        remainig_days: null,
        duration: 0,
        duration_type: 1,
        day_type: 2,
        // first_half_of_end_date: false,
        // second_half_start_date: false,
        reason: null,
        leave_type: "weekly",
      }),
      dbDurationList: [
        { id: 1, short_name: "1st", long_name: "First" },
        { id: 2, short_name: "2nd", long_name: "Second" },
        { id: 3, short_name: "3rd", long_name: "Third" },
        { id: 4, short_name: "4th", long_name: "Fourth" },
        { id: 5, short_name: "Last", long_name: "Last" },
      ],
      weekDays: [
        { id: 2, short_name: "Mon", long_name: "Monday" },
        { id: 3, short_name: "Tue", long_name: "Tuesday" },
        { id: 4, short_name: "Wed", long_name: "Wednesday" },
        { id: 5, short_name: "Thu", long_name: "Thursday" },
        { id: 6, short_name: "Fri", long_name: "Friday" },
        { id: 7, short_name: "Sat", long_name: "Saturday" },
      ],
    };
  },
  watch: {
    recurringSchedule: {
      handler(param) {
        if (param) {
          this.getJobSchedule(this.recurringSchedule.type);
        }
      },
      deep: true
    },
    start_date() {
      this.categoryDays();
    },
    "leaveCreate.duration_type": {
      handler(param) {
        if (param == 1) {
          this.leaveCreate.day_type = 2;
        }
        if (param == 2) {
          this.leaveCreate.day_type = 1;
        }
      },
    },
    "recurringSchedule.end_mode"(newVal) {
      if (newVal === 2) {
        this.recurringSchedule.end_date = "";
      }
    },

    "leaveCreate.staff": {
      handler(param) {
        this.init(param);
      },
    },

    leaveUpdateData: {
      handler(param) {
        if (param) {
          this.init(param);
        }
      },
    },
  },
  methods: {
    onStaffInput(val) {
      if (val === null) {
        this.userData = {};
        this.updateValues();
      } else {
        // this.leaveCreate.staff = val;
      }
    },
    goBack() {
      this.$emit("close");
    },
    allowedDates(val) {
      const date = new Date(val);
      const isNotSunday = date.getDay() !== 0; // Allow only non-Sundays
      const isInCustomList = !this.holidays.includes(val);
      const existedLeave = !this.recurringSchedule.existedLeave.includes(val);
      return isNotSunday && isInCustomList && existedLeave;
    },
    isWeekend(date) {
      if (!date) return false;
      const day = moment(date).day();

      return day === 0 || day === 6;
    },

    async getJobSchedule(type) {
      if (type) {
        console.log(345345, type);
        let value = await this.$store.dispatch(GET_RECURRING_LEAVE_DATE);
        if (!value) {
          // this.leaveDialog = false;
        }
        else {
          // this.leaveDialog = true;
        }
      }
    }
    ,
    nextStepSchedule() {
      this.leaveDialog = false;
      // this.$nextTick(() => {
      //   this.uniqueCId = Number(new Date());
      //   this.scheduleConfirmDialog = true;
      // });
    },
    updateValues() {
      this.updateScheduleState("dbRecurringSchedule.occurrence", 1);
      this.updateScheduleState("dbRecurringSchedule.weeks", []);
      this.updateScheduleState("dbScheduleOutput", []);
      // this.updateScheduleState("recurringSchedule.type", '');

      this.updateEndDate(true);
    },
    updateLeaveOccurrence() {
      this.updateScheduleState("dbRecurringSchedule.occurrence", 1);
      // this.updateScheduleState("dbRecurringSchedule.end_date", null);
    },
    continueData() {
      (this.is_visit_validated = 0), console.log(this.is_visit_validated);
      this.statusDialog = false;
    },
    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    formatetimedata(row) {
      return moment(row).format("hh:mm A");
    },
    calculateDate(data, e, type) {
      if (type == "category") {
        this.start_date = null;
        this.end_date = null;
        return false;
      }

      if (data.id == null && data.category != "UnPaid") {
        let firstDay = moment(this.start_date);
        let lastDay = moment(this.end_date);
        if (type == "start" && e) {
          firstDay = moment(e);
        } else {
          lastDay = moment(e);
        }

        if (firstDay && lastDay) {
          let calcBusinessDays =
            1 +
            (lastDay.diff(firstDay, "days") * 5 -
              (firstDay.day() - lastDay.day()) * 2) /
            7;
          if (lastDay.day() == 6) calcBusinessDays--; //SAT
          if (firstDay.day() == 0) calcBusinessDays--; //SUN

          // Count holidays between dates
          let currentDate = moment(firstDay);
          while (currentDate <= lastDay) {
            if (this.isHoliday(currentDate)) {
              calcBusinessDays--;
            }
            currentDate.add(1, "days");
          }

          if (this.leaveCreate.duration == 1) {
            calcBusinessDays = calcBusinessDays - 0.5;
          }

          this.totalDuration = calcBusinessDays;
          if (this.remainingLeaves < this.totalDuration) {
            this.leaveCreate.duration = 1;
            this.diableDay = true;
          } else {
            this.leaveCreate.duration = 0;
            this.diableDay = false;
          }
        }
      }
    },
    getColor(data) {
      if (data == 1) {
        return "blue";
      } else if (data == 2) {
        return "yellow";
      } else if (data == 3) {
        return "red";
      } else if (data == 4) {
        return "green";
      } else if (data == 5) {
        return "red";
      } else if (data == 6) {
        return "cyan";
      }
    },
    getBusinessDays() {
      if (!this.start_date || !this.end_date) return 0;

      var lastDay = moment(this.end_date);
      var firstDay = moment(this.start_date);
      let calcBusinessDays =
        1 +
        (lastDay.diff(firstDay, "days") * 5 -
          (firstDay.day() - lastDay.day()) * 2) /
        7;
      if (lastDay.day() == 6) calcBusinessDays--; //SAT
      if (firstDay.day() == 0) calcBusinessDays--; //SUN

      let currentDate = moment(firstDay);
      while (currentDate <= lastDay) {
        if (this.isHoliday(currentDate)) {
          calcBusinessDays--;
        }
        currentDate.add(1, "days");
      }

      if (Number(calcBusinessDays) < 0) {
        calcBusinessDays = 0;
      }

      return calcBusinessDays;
    },
    updateTotalDays() {
      if (this.start_date === this.end_date) {
        // if (this.leaveCreate.first_half_of_end_date && this.leaveCreate.second_half_start_date) {
        //   this.leaveCreate.first_half_of_end_date = false;
        //   this.leaveCreate.second_half_start_date = false;
        // }
      }
      this.getBusinessDays();
    },
    getProvision(proDate) {
      let a = moment();
      let b = moment(proDate);
      this.probisionTime = b.diff(a, "days");
    },
    changeData(data) {
      if (data == true) {
        this.leaveCreate.duration = 1;
      } else {
        this.leaveCreate.duration = 0;
      }
      if (this.start_date && this.end_date) {
        this.getBusinessDays();
      }
    },
    init(param) {
      if (param && param.id) {
        this.leaveCreate = {
          id: param.id,
          staff: (param.staff && param.staff.id) || null,
          category: (param.category && param.category) || null,
          duration: param.duration || 0,
          duration_type: toSafeInteger(param.duration_type) || 1,
          reason: param.reason || null,
          // first_half_of_end_date: param.first_half_of_end_date || false,
          // second_half_start_date: param.second_half_start_date || false,
          day_type: toSafeInteger(param.day_type) || 1,
        };
        this.start_date = param.start_date || null;
        this.end_date = param.end_date || null;
        if (this.leaveCreate.staff > 0) {
          // this.getUser(this.leaveCreate.staff);
          this.getCategoryOptions(this.leaveCreate.staff);
          /* this.categoryDays(); */
        }
      }
    },
    getMaxDate(mindate, remainig_days) {
      if (remainig_days <= 0) {
        return moment(mindate, "YYYY-MM-DD")
          .add(Math.floor(remainig_days) - 1, "days")
          .format("YYYY-MM-DD");
      }
      return null;
    },
    currentUserData() {
      const user = getCurrentUser();
      if (user && user.role != "Admin") {
        this.leaveCreate.staff = user.id;
      }
      return user;
    },

    getOptions() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "leave/options",
        })
        .then(({ data }) => {
          _this.userList = data.users;
          _this.holidays = data.holiday;
          _this.categoryList = data.leave_type;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateEndDate(force) {
      let startDateTime = moment(
        `${this.recurringSchedule.start_date} ${this.recurringSchedule.start_time}`
      );
      let endDateTime = moment(
        `${this.recurringSchedule.end_date} ${this.recurringSchedule?.end_time}`
      );

      if (force === true || endDateTime.isSameOrBefore(startDateTime)) {
        let endDate = null;
        switch (this.recurringSchedule?.type) {
          case "date_range":
            endDate = startDateTime.add(1, "day").format("YYYY-MM-DD");
            this.recurringSchedule.end_date = startDateTime.add(7, "day").format("YYYY-MM-DD");
            break;
          case "weekly":
            endDate = startDateTime.add(7, "day").format("YYYY-MM-DD");
            this.recurringSchedule.end_date = startDateTime.add(12, "month").format("YYYY-MM-DD");
            break;
          case "monthly":
            endDate = startDateTime.add(12, "month").format("YYYY-MM-DD");
            this.recurringSchedule.end_date = startDateTime.add(12, "month").format("YYYY-MM-DD");
        }
        let formatDateEndDate = moment(endDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
        this.updateScheduleState(
          "dbRecurringSchedule.end_date",
          formatDateEndDate
        );
      }
    },
    updateSchedule() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.getJobSchedule();
      }, 200);
    },
    updateScheduleState(key, value) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });

      // this.$store.commit(RESET_ENGINEER);
      this.updateDefaultDate();
      // this.updateSchedule();
    },
    updateSelection() {


      this.$nextTick(() => {
        this.updateSchedule();
      });
    },
    allowedSelections() {
      const selectedFrequencyData = this.leaveScheduleTypeList.find(
        (item) => item.value === this.recurringSchedule?.type?.value
      );
      return selectedFrequencyData ? selectedFrequencyData?.max_allowed : 0;
    },
    updateDefaultDate() {
      this.$nextTick(() => {
        this.$store.dispatch(UPDATE_DEFAULT_DATE, "leave");
      });
    },
    categoryDays() {
      const _this = this;
      let categoryData = filter(_this.categoryList, function (row) {
        return row.leave == _this.leaveCreate.category;
      });

      if (categoryData[0] && categoryData[0].balance) {
        let maxDate = toString(
          moment(this.start_date, "YYYY-MM-DD")
            .add(
              Math.ceil(
                toSafeInteger(categoryData[0].balance) +
                toSafeInteger(this.weekEndDays)
              ) - 1,
              "days"
            )
            .format("YYYY-MM-DD")
        );

        var lastDay = moment(maxDate);
        var firstDay = moment(this.start_date);
        let calcBusinessDays =
          1 +
          (lastDay.diff(firstDay, "days") * 5 -
            (firstDay.day() - lastDay.day()) * 2) /
          7;
        if (lastDay.day() == 6) calcBusinessDays--; //SAT
        if (firstDay.day() == 0) calcBusinessDays--; //SUN

        // Count holidays between dates
        let currentDate = moment(firstDay);
        while (currentDate <= lastDay) {
          if (this.isHoliday(currentDate)) {
            calcBusinessDays--;
          }
          currentDate.add(1, "days");
        }

        let addWeekends = categoryData[0].balance - calcBusinessDays;

        if (addWeekends > 0) {
          this.weekEndDays = this.weekEndDays + addWeekends;
          this.categoryDays();
        } else {
          this.weekEndDays = 0;
          this.maxDate = maxDate;
          this.remainingLeaves = categoryData[0].balance;
          this.apprveLeaves = categoryData[0].taken;
          this.pendingLeaves = categoryData[0].pending;
          this.allocated = categoryData[0].allocated_days;
        }
      }
    },
    getCategoryOptions(userList = 0) {
      if (userList == 0) {
        const user = getCurrentUser();
        if (user && user.role == "Staff") {
          userList = user.id;
        } else {
          return false;
        }
      }

      if (userList > 0) {
        const _this = this;
        _this.pageLoading = true;
        _this.categoryDays();
        _this.$store
          .dispatch(GET, {
            url: "setting/leave/option/" + userList,
          })
          .then((data) => {
            // _this.categoryList = data.data.categories;
            _this.userData = data.data;

            this.$store.commit(UPDATE_SCHEDULE_STATE, {
              key: "recurringSchedule.existedLeave",
              value: data.data.all_leaves,
            });
            _this.recurringSchedule.existedLeave = data.data.all_leaves;
            if (this.leaveCreate.id == null) {
              _this.categoryDays();
            }
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.pageLoading = false;
          });
      }
      /* 	this.categoryDays(); */
    },
    getUser(id) {
      this.$store
        .dispatch(GET, { url: `single-user/${id}` })
        .then((data) => {
          this.userData = data.data;
          this.getProvision(this.userData.provision_date);
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    CreateOrUpdateLeave() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs["leaveForm"]);
      _this.$refs["leaveForm"].validate();
      if (formErrors.length) {
        _this.errors = [];
        this.$store.commit(SET_ERROR, this.errors.concat(formErrors));
        return false;
      }
      if (!_this.$refs["leaveForm"].validate()) {
        return false;
      }
      _this.pageLoading = true;
      let leaveId = _this.leaveCreate.id || 0;
      let staff = _this.leaveCreate.staff || null;

      if (!staff) {
        const user = getCurrentUser();
        staff = user.id;
      }
      if (this.leaveCreate.duration == true) {
        this.leaveCreate.duration = 1;
      } else {
        this.leaveCreate.duration = 0;
      }
      if (!this.leaveCreate.reason) {
        ErrorEventBus.$emit("update:error", "Leave Reason is required.");
        this.pageLoading = false;
        return false;
      }
      this.pageLoading = true;
      let formData = new FormData();
      formData.append(
        "staff",
        this.leaveCreate.staff ? this.leaveCreate.staff : 0
      );
      if (this.leaveCreate.category) {
        formData.append(
          "category",
          this.leaveCreate.category ? this.leaveCreate.category : null
        );
      }

      formData.append(
        "duration",
        this.leaveCreate.duration ? this.leaveCreate.duration : 0
      );
      formData.append(
        "is_visit_validated",
        this.is_visit_validated && this.is_visit_validated == 1 ? 1 : 0
      );
      formData.append(
        "duration_type",
        this.leaveCreate.duration_type ? this.leaveCreate.duration_type : 1
      );
      formData.append("schedule", JSON.stringify(this.scheduleLeaveOutput));

      formData.append("total_leave_days", this.getBusinessDays());
      if (this.leaveCreate && this.leaveCreate.reason) {
        formData.append(
          "reason",
          this.leaveCreate.reason ? this.leaveCreate.reason : null
        );
      }
      if (this.recurringSchedule?.type) {
        formData.append(
          "leave_types",
          this.recurringSchedule.type ? this.recurringSchedule.type : null
        );
      }

      if (this.recurringSchedule?.start_date) {
        formData.append(
          "start_date",
          this.recurringSchedule.start_date
            ? this.recurringSchedule.start_date
            : null
        );
      }

      if (this.leaveCreate && this.leaveCreate.day_type) {
        formData.append(
          "day_type",
          this.leaveCreate.day_type ? this.leaveCreate.day_type : 1
        );
      }
      if (this.recurringSchedule?.end_date) {
        formData.append(
          "end_date",
          this.recurringSchedule.end_date
            ? this.recurringSchedule.end_date
            : this.recurringSchedule.start_date
        );
      }
      if (this.files && this.files.length) {
        for (let i = 0; i < this.files.length; i++) {
          if (this.files && this.files[i] && this.files[i].file) {
            formData.append(`file[${i}][file]`, this.files[i].file);
            formData.append(`file[${i}][name]`, this.files[i].name);
          }
        }
      }
      let requestTYPE = POST;
      let requestURL = "leave";

      if (leaveId > 0) {
        requestURL = `leave/${leaveId}`;
      }
      this.$store
        .dispatch(requestTYPE, {
          url: requestURL,
          data: formData,
        })
        .then((data) => {
          this.visitArr = data.data;
          if (
            this.visitArr &&
            this.visitArr.length > 0 &&
            this.is_visit_validated == 1
          ) {
            this.statusDialog = true;
            return false;
          }
          this.updateValues();
          if (leaveId > 0) {
            this.$store.commit(SET_MESSAGE, [
              { model: true, message: "Success ! Leave updated successfully." },
              this.$emit("close"),
              LeaveApplyEventBus.$emit("refresh"),
              /* this.leaveCreate = {} */
            ]);
          } else {
            this.$store.commit(SET_MESSAGE, [
              { model: true, message: "Success ! Leave added successfully." },
              this.$emit("close"),
            ]);
          }
          /* 	LeaveEventBus.$emit("refresh", true); */
          LeaveApplyEventBus.$emit("refresh"), this.$emit("refresh-data", true);
          this.$store.dispatch(GET_LEAVE_STATUS, {});
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    resetDate(row) {
      if (row.balance == 0 && row.category != "UnPaid") {
        this.blankdate = true;
      } else {
        this.blankdate = false;
      }
    },
    isHoliday(date) {
      if (!date) return false;
      // const dateStr = moment(date).format('YYYY-MM-DD');
      // return this.holidays.includes(dateStr);
    },
  },
  created() {
    if (this.leaveCreate.staff > 0) {
      this.getCategoryOptions();
    }
  },

  mounted() {
    const _this = this;
    _this.getOptions();
    /* _this.categoryDays(); */

    _this.getProvision(this.userData.provision_date);
    _this.init(this.leaveUpdateData);
    _this.leave = toSafeInteger(_this.$route.params.id);
  },

  computed: {
    ...mapGetters([
      "vShowCalendar",
      "scheduleLeaveOutput",
      "recurringSchedule",
      "leaveScheduleTypeList",
      "durationList",
    ]),
    validDates() {
      if (!this.start_date || !this.end_date) return [];

      const validDates = [];
      const excludesDatess = [];
      let currentDate = moment(this.start_date);
      const endDate = moment(this.end_date);

      while (currentDate <= endDate) {
        if (!this.isHoliday(currentDate) && !this.isWeekend(currentDate)) {
          validDates.push(currentDate.format("YYYY-MM-DD"));
        } else {
          excludesDatess.push(currentDate.format("YYYY-MM-DD"));
        }
        currentDate.add(1, "days");
      }

      return [validDates, excludesDatess];
    },
    is_staff() {
      const user = this.currentUserData();
      const role_name = user.role;
      return role_name != "Admin";
    },
    disabledDate() {
      let catData = find(
        this.categoryList,
        (row) => row.leave == this.leaveCreate.category
      );

      if (
        (catData && catData.balance > 0) ||
        this.leaveCreate.category == "UnPaid"
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>
